import React from 'react';
import { useTranslation } from 'react-i18next';

import HoverText from './HoverText';
import styles from './ExpensesMonthly.scss';

const MonthlyExpenseStatus = ({ hasNoExpensesData, isConfirmed, unConfirmedList }) => {
  const { t } = useTranslation();

  return (
    <div className="u-mb20" style={{ visibility: hasNoExpensesData() ? 'hidden' : '' }}>
      {!isConfirmed && (
        <div id="total-unconfirmed" className={styles.totalUnConfirmed}>
          {`* ${t('features.Dashbord.components.ExpensesMonthly.subject_to_change')}`}
          <HoverText>
            {t('features.Dashbord.components.ExpensesMonthly.un_confirmed')}
            {unConfirmedList?.length > 0 && unConfirmedList?.map(item => <li key={`unConf-${item}`}>{item}</li>)}
          </HoverText>
        </div>
      )}
      {isConfirmed && (
        <div id="total-confirmed" className={styles.totalConfirmed}>
          {t('features.Dashbord.components.ExpensesMonthly.confirmed')}
        </div>
      )}
    </div>
  );
};

export default MonthlyExpenseStatus;
